import React, { useState, useEffect } from 'react';

import './styles.scss';

export default function QuickAccess({
  quickAccess,
  isQuickAccessOpen,
  handleSendId,
  handleCloseQuickAccess,
  channel,
}) {
  const [quickAccessList, setQuickAccessList] = useState([]);
  const [isQuickAccessActive, setIsQuickAccessActive] = useState(
    isQuickAccessOpen || false
  );
  const [webChannel, setwebChannel] = useState(channel || '');

  const listRule = {
    manual: 'manualList',
    lastday: 'lasdayList',
    lastweek: 'lastweekList',
    lastmonth: 'lastmonthList',
  };

  useEffect(() => {
    if (quickAccess && quickAccess.quickAccessActive) {
      const rule = quickAccess.sortingRules;
      if (
        rule !== '' &&
        quickAccess[`${listRule[rule]}`] &&
        quickAccess[`${listRule[rule]}`].length > 0
      ) {
        setQuickAccessList(quickAccess[`${listRule[rule]}`]);
        if (channel) {
          setwebChannel(channel);
        }
      }
    }
  }, [quickAccess]);

  useEffect(() => {
    setIsQuickAccessActive(isQuickAccessOpen);
  }, [isQuickAccessOpen]);

  const handleQuickAccessLiClick = (itemId, title) => {
    handleSendId({ itemId, title });
    handleCloseQuickAccess();
  };

  return (
    <div
      id="quick-access-container-list"
      className={`quick-access-container ${webChannel}`}
      style={
        isQuickAccessActive
          ? { opacity: 1, zIndex: 999 }
          : { opacity: 0, zIndex: -1 }
      }
    >
      <div className="quick-access-list-header">Acesso Rápido</div>
      <ul className="quick-access-list">
        {quickAccessList.map((item) => {
          return (
            <li
              key={item._id}
              onClick={() => handleQuickAccessLiClick(item._id, item.title)}
            >
              <div className="quick-access-text">{item.title}</div>
              <div className="quick-access-div" />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
